import { AppButton, AppRadioBox, AppSwitchBox, AppTextField } from 'components';
import { memo, useContext, useEffect, useState } from 'react';
import { getRandomUid } from 'utilities/uuid.service';
import * as AppPics from 'assets/images';
import Editor from 'components/CKEditor/Editor';
import { ReactSortable } from 'react-sortablejs';
import { EditorPreviewContext } from 'context/EditorPreviewContext';
import useDebounce from 'hooks/useDebounce';

function MCQ({ selectedCategory, handleSave, data }) {
  const { PreviewBtn } = useContext(EditorPreviewContext);

  const [category, setCategory] = selectedCategory;
  const __choiceID = getRandomUid();

  const [currentEdited, updateCurrentEditBlock] = useState({});

  const editorData = useDebounce(currentEdited, 100);

  useEffect(() => {
    if (editorData.id) {
      updateCurrentEditBlock(editorData);
      handleSave({
        options: data?.options?.map((x) => {
          if (x.id === editorData.id) x.option = editorData.data;
          return x;
        }),
      });
    }
  }, [editorData]);

  return (
    <>
      <div className="tab__content-actBody">
        <div className="px-5">
          {true && (
            <div className="row mt-4">
              <div className="col-md-12 col-lg-12 col-sm-12">
                <div className="lessonWrap lessonWrap--border topalign __M_C_Q___sub">
                  <label htmlFor="">QUESTION </label>
                  <div className="w-50">
                    <div className="d-flex align-items-center">
                      <span className="radioBlock">
                        <input
                          id={`choice${__choiceID}`}
                          name={`choice${__choiceID}`}
                          value={`choice${__choiceID}`}
                          type="radio"
                          defaultChecked={true}
                        />
                        <label htmlFor={`choice${__choiceID}`}>
                          Multiple Choice Question having
                        </label>
                      </span>
                    </div>
                    <div className="w-75 p-3">
                      <select
                        required
                        value={category}
                        onChange={(event) => {
                          if (event.target.value === 'single') {
                            handleSave({
                              options: data?.options?.map?.((x) => {
                                x.isCorrect = false;
                                return x;
                              }),
                            });
                          }
                          setCategory(event.target.value);
                        }}
                      >
                        <option value="single">Only One Correct Answer</option>
                        <option value="multiple">More than One Correct Answer</option>
                      </select>
                    </div>
                  </div>

                  <div className="w-100 p-3">
                    <label htmlFor="">Question</label>
                    {data?.title && <PreviewBtn block={{ value: data.title }} />}
                    <Editor
                      data={{
                        value: data?.title || '',
                        onChange: (editorData) => {
                          handleSave({ title: editorData });
                        },
                      }}
                    />
                  </div>

                  <ReactSortable
                    list={data?.options}
                    setList={(newState) =>
                      handleSave({
                        options: newState,
                      })
                    }
                    handle=".grabHandleID"
                  >
                    {data?.options?.map((choice, index) => {
                      return (
                        <div className="lessonWrap  topalign py-0 grabHandleID" key={choice.id}>
                          <div className="w-100 p-3">
                            <label htmlFor="">Choice #{index + 1}</label>
                            <span className="radioBlock floatright">
                              {category === 'single' && (
                                <AppRadioBox
                                  inputProps={{
                                    id: `choice-${choice.id}`,
                                    name: `choice-${choice.id}`,
                                    checked: choice.isCorrect,
                                    onChange: () => {
                                      handleSave({
                                        options: data?.options?.map?.((x) => {
                                          x.isCorrect = false;
                                          if (x.id === choice.id) x.isCorrect = true;
                                          return x;
                                        }),
                                      });
                                    },
                                  }}
                                  labelProps={{ label: 'This is the correct Answer' }}
                                />
                              )}
                              {category === 'multiple' && (
                                <AppSwitchBox
                                  inputProps={{
                                    checked: choice.isCorrect,
                                    onChange: (event) => {
                                      handleSave({
                                        options: data?.options?.map?.((x) => {
                                          if (x.id === choice.id)
                                            x.isCorrect = event.target.checked;
                                          return x;
                                        }),
                                      });
                                    },
                                  }}
                                  labelProps={{ label: 'This is a correct answer' }}
                                />
                              )}
                            </span>

                            <AppButton
                              variantClass="lessonWrap__btn leftpos dublicate"
                              title="Clone"
                              onClick={() => {
                                handleSave({
                                  options: data?.options?.concat({
                                    id: getRandomUid(),
                                    option: choice.option,
                                    isCorrect: false,
                                  }),
                                });
                              }}
                            >
                              <img src={AppPics.StampSvg} alt="clone this option" />
                            </AppButton>
                            <AppButton
                              variantClass="lessonWrap__btn leftpos delete"
                              onClick={() => {
                                handleSave({
                                  options: data?.options.filter((x) => x.id !== choice.id),
                                });
                              }}
                            >
                              <img src={AppPics.DeleteSvg} alt="delete this option" />
                            </AppButton>
                            {choice.option && <PreviewBtn block={{ value: choice.option }} />}
                            <Editor
                              data={{
                                value: choice.option,
                                onChange: (data) => {
                                  updateCurrentEditBlock({ id: choice.id, data });
                                  // handleSave({
                                  //   options: data?.options?.map((x) => {
                                  //     if (x.id === choice.id) x.option = editorData;
                                  //     return x;
                                  //   }),
                                  // });
                                },
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </ReactSortable>

                  <div className="col-12">
                    <AppButton
                      variantClass="btn-plane p--tint m-l-btn"
                      onClick={() => {
                        handleSave({
                          options: data?.options?.concat({
                            id: getRandomUid(),
                            option: '',
                            isCorrect: false,
                          }),
                        });
                      }}
                    >
                      + Add Choice
                    </AppButton>
                  </div>

                  <div className="w-100 p-3 mt-4">
                    <label htmlFor="">Hint</label>
                    {data?.hint && <PreviewBtn block={{ value: data?.hint || '' }} />}
                    <Editor
                      data={{
                        value: data?.hint || '',
                        onChange: (data) => handleSave({ hint: data }),
                      }}
                    />
                  </div>

                  <div className="w-100 p-3">
                    <label htmlFor="">Explanation</label>
                    {data?.explanation && <PreviewBtn block={{ value: data?.explanation || '' }} />}
                    <Editor
                      data={{
                        value: data?.explanation || '',
                        onChange: (data) => handleSave({ explanation: data }),
                      }}
                    />
                  </div>
                  <div className="w-100 p-3">
                    <AppTextField
                      labelProps={{ label: 'Marks' }}
                      inputProps={{
                        placeholder: 'Please provide the maximum marks allocated',
                        value: data?.marks || '',
                        onChange: (event) => handleSave({ marks: event.target.value }),
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default memo(MCQ);
